<template>
  <div class="mt-wrap">
    <ProgressBar v-if="loading[0] || loader" mode="indeterminate"
      style="height:3px;position:fixed;top:0;left:0;right:0;z-index:9999;border-radius:0"/>

    <!-- ── Topbar ── -->
    <div class="mt-topbar">
      <div class="field col-12">
        <!-- {{indicadores_viajes}} -->
			<!-- Header -->
        <div class="dashboard-header-movimientos">
          <h1><i class="pi pi-truck" style="font-size: 2rem"></i> Panel de Control de Viajes</h1>
          <p>Gestione y analice el estado de todos los viajes SEWAY Plus</p>
        </div>
      </div>
      <!-- <button class="mt-btn-outline" @click="openFiltersExport">
        <i class="pi pi-file-excel"></i> Exportar
      </button> -->
    </div>

    <!-- ── Panel búsqueda ── -->
    <div class="mt-search-panel">
      <div class="mt-search-section-label">
        <i class="pi pi-building"></i> Empresa de transporte
      </div>
      <div class="mt-search-top">
        <div class="mt-form-field" style="flex:1">
          <label>Seleccione empresa</label>
          <Dropdown v-model="customer_selected" :onChange="select_proveedor"
            :showClear="true" ref="customer_selected"
            :options="customers_group" optionLabel="name" optionValue="id_customer"
            placeholder="Seleccione una empresa…" />
        </div>
        <div class="mt-search-top-btns">
          <button class="mt-btn-primary" @click="load(0,1)" :disabled="loading[0]">
            <i class="pi pi-search"></i> Buscar
          </button>
          <button class="mt-btn-outline" @click="limpiar" :disabled="loading[0]">
            <i class="pi pi-filter-slash"></i> Limpiar
          </button>
        </div>
      </div>

      <template v-if="customer_selected != null">
        <div class="mt-search-section-label" style="margin-top:1rem">
          <i class="pi pi-filter"></i> Filtros adicionales
        </div>
        <div class="mt-filtros-grid">
          <div class="mt-form-field">
            <label>Generador</label>
            <Dropdown v-model="select_estado" :showClear="true"
              :options="generadores.length ? generadores : []"
              optionLabel="nombrecompleto" optionValue="documento"
              :placeholder="generadores.length ? 'Seleccione un generador' : 'Cargue primero los movimientos'" />
          </div>
          <div class="mt-form-field">
            <label>Placa</label>
            <InputMask mask="aaa-999" v-model="placa" placeholder="ABC-123" />
          </div>
          <div class="mt-form-field">
            <label>Número movimiento</label>
            <InputText v-model="num_movimiento" type="number" placeholder="Núm. movimiento" />
          </div>
          <div class="mt-form-field">
            <label>
              Fecha
              <span class="mt-range-toggle">
                <Checkbox id="chkRango" :binary="true" v-model="frmfiltros.rangofechasolicitud" />
                <label for="chkRango" style="font-size:.72rem;font-weight:600;color:#6b7280;cursor:pointer">
                  Rango
                </label>
              </span>
            </label>
            <Calendar v-model="text_filter" :showButtonBar="true" :showIcon="true"
              locale="es" placeholder="Fecha inicio" />
          </div>
          <div class="mt-form-field" v-if="frmfiltros.rangofechasolicitud">
            <label>Fecha fin</label>
            <Calendar v-model="frmfiltros.fechasolicitudrango"
              :minDate="text_filter" :showButtonBar="true" :showIcon="true"
              locale="es" placeholder="Fecha fin" />
          </div>
        </div>
      </template>
    </div>

    <!-- ── Tabla ── -->
    <template v-if="customer_selected != null">
      <div class="mt-tabla-wrap">
        <table class="mt-tabla">
          <thead>
            <tr>
              <th>Movimiento</th>
              <th>Sucursal / Operación</th>
              <th>Generador</th>
              <th>Placa / Fecha</th>
              <th>Factura / Estado</th>
              <th style="width:160px;text-align:center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="detalle_movimientos.length === 0 && !loading[0]">
              <td colspan="6" class="mt-empty">
                <i class="pi pi-truck"></i>
                <p>No se encontraron movimientos con los filtros aplicados</p>
              </td>
            </tr>
            <tr v-for="(item, i) in detalle_movimientos" :key="i">
              <td>
                <div class="mt-cell-label">Mov. Transporte</div>
                <div class="mt-ref">{{ item.movimiento_numero }}</div>
              </td>
              <td>
                <div class="mt-cell-sub">{{ item.sucorigina_nombre }}</div>
                <div class="mt-cell-op">{{ item.movimiento_operacion }}</div>
              </td>
              <td>
                <div class="mt-gen-name">{{ item.generador_nombre }}</div>
              </td>
              <td>
                <template v-if="item.vehiculo_placa == null">
                  <span class="mt-badge mt-badge--naranja">Pendiente asignación</span>
                </template>
                <template v-else>
                  <span class="mt-placa">{{ item.vehiculo_placa }}</span>
                </template>
                <div class="mt-fecha">{{ item.movimiento_fecha }}</div>
              </td>
              <td>
                <div class="mt-cell-sub">{{ item.factura_comprobante }}</div>
                <div class="mt-estado">{{ item.movimiento_estado }}</div>
              </td>
              <td style="text-align:center">
                <div class="mt-row-actions">
                  <button class="mt-btn-icon" title="Detalle movimiento"
                          @click="verDetalle(item, {index: i})" :disabled="loading[i]">
                    <i class="pi pi-book"></i>
                  </button>
                  <button class="mt-btn-icon" title="Actores"
                          @click="openactores(item, {index: i})" :disabled="loading[i]">
                    <i class="pi pi-users"></i>
                  </button>
                  <button class="mt-btn-icon" title="Cumplidos"
                          @click="openModalcumplidos(item, {index: i})" :disabled="loading[i]">
                    <i class="pi pi-check-square"></i>
                  </button>
                  <button v-if="item.id_viaje != null"
                          class="mt-btn-icon mt-btn-icon--sigueme" title="Sígueme"
                          @click="openModalDetalleSigueme(item, {index: i})" :disabled="loading[i]">
                    <i class="pi pi-truck"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <template v-if="loading[0] && detalle_movimientos.length === 0">
          <div class="mt-skeleton-wrap">
            <div v-for="n in 6" :key="n" class="mt-skeleton-row"></div>
          </div>
        </template>

        <div class="mt-pagination">
          <span>{{ pagination.from }}–{{ pagination.to }} de {{ pagination.total }} movimientos</span>
          <Paginator :v-model:first="pagination.from" :rows="pagination.per_page"
            :rowsPerPageOptions="[15]" :totalRecords="pagination.total"
            @page="onChangePage($event)" class="mt-paginator" />
        </div>
      </div>
    </template>

    <!-- ══ MODAL: Actores ══ -->
    <Dialog v-model:visible="modalActores" :style="{width:'680px'}"
            header="Información de actores" :modal="true" class="mt-dialog">
      <div class="mt-modal-body">
        <div class="mt-actor-section">
          <div class="mt-actor-section-header">
            <div class="mt-actor-icon" style="background:#eff6ff"><i class="pi pi-user" style="color:#1e40af"></i></div>
            <div>
              <div class="mt-actor-title">Conductor</div>
              <div class="mt-actor-sub">Conductor asignado al movimiento</div>
            </div>
            <div v-if="img_conductor.length > 0" style="margin-left:auto">
              <Galleria :value="img_conductor" :responsiveOptions="galleriaResponsiveOptions"
                :numVisible="3" :circular="true" containerStyle="max-width:130px">
                <template #item="slotProps">
                  <img :src="slotProps.item.url" :alt="slotProps.item.identificacion"
                    style="width:100%;border-radius:6px" />
                </template>
              </Galleria>
            </div>
          </div>
          <div class="mt-info-grid">
            <div class="mt-info-item"><span class="mt-info-label">Nombre</span><span class="mt-info-value">{{ data_fila.conductor_nombre }}</span></div>
            <div class="mt-info-item"><span class="mt-info-label">Cédula</span><span class="mt-info-value">{{ data_fila.conductor_documento }}</span></div>
          </div>
        </div>
        <div class="mt-actor-section">
          <div class="mt-actor-section-header">
            <div class="mt-actor-icon" style="background:#fff7ed"><i class="pi pi-briefcase" style="color:#9a3412"></i></div>
            <div><div class="mt-actor-title">Propietario</div><div class="mt-actor-sub">Propietario del vehículo</div></div>
          </div>
          <div class="mt-info-grid">
            <div class="mt-info-item"><span class="mt-info-label">Nombre</span><span class="mt-info-value">{{ data_fila.propietario_nombre }}</span></div>
            <div class="mt-info-item"><span class="mt-info-label">Cédula</span><span class="mt-info-value">{{ data_fila.propietario_documento }}</span></div>
          </div>
        </div>
        <div class="mt-actor-section">
          <div class="mt-actor-section-header">
            <div class="mt-actor-icon" style="background:#f0fdf4"><i class="pi pi-id-card" style="color:#166534"></i></div>
            <div><div class="mt-actor-title">Asesor</div><div class="mt-actor-sub">Asesor asignado</div></div>
          </div>
          <div class="mt-info-grid">
            <div class="mt-info-item"><span class="mt-info-label">Nombre</span><span class="mt-info-value">{{ data_fila.asesor_nombre }}</span></div>
            <div class="mt-info-item"><span class="mt-info-label">Cédula</span><span class="mt-info-value">{{ data_fila.asesor_documento }}</span></div>
          </div>
        </div>
        <div class="mt-actor-section">
          <div class="mt-actor-section-header">
            <div class="mt-actor-icon" style="background:#faf5ff"><i class="pi pi-truck" style="color:#7c3aed"></i></div>
            <div><div class="mt-actor-title">Vehículo</div><div class="mt-actor-sub">Datos del vehículo</div></div>
          </div>
          <div class="mt-info-grid">
            <div class="mt-info-item">
              <span class="mt-info-label">Placa</span>
              <span class="mt-info-value"><span class="mt-placa">{{ data_fila.vehiculo_placa }}</span></span>
            </div>
            <div class="mt-info-item"><span class="mt-info-label">Clase</span><span class="mt-info-value">{{ data_fila.movimiento_claseveh }}</span></div>
          </div>
          <div v-if="img_vehiculo.length > 0" style="margin-top:.75rem">
            <Galleria :value="img_vehiculo" :responsiveOptions="galleriaResponsiveOptions"
              :numVisible="3" :circular="true" containerStyle="max-width:200px">
              <template #item="slotProps">
                <img :src="slotProps.item.url" :alt="slotProps.item.identificacion" style="width:100%;border-radius:6px" />
              </template>
              <template #thumbnail="slotProps">
                <img :src="slotProps.item.url" :alt="slotProps.item.identificacion" style="width:100%" />
              </template>
            </Galleria>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="mt-btn-outline" @click="modalActores = false"><i class="pi pi-times"></i> Cerrar</button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Cumplidos ══ -->
    <Dialog v-model:visible="modalcumplidos" :style="{width:'700px'}"
            header="Cumplidos" :modal="true" class="mt-dialog">
      <div class="mt-modal-body">
        <template v-if="cumplidos.length > 0">
          <div class="mt-tabla-wrap" style="margin:0">
            <table class="mt-tabla">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th>Fecha</th>
                  <th style="width:80px;text-align:center">Enlace</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, ci) in cumplidos" :key="ci">
                  <td>{{ c.nombre }}</td>
                  <td>{{ c.fecha }}</td>
                  <td style="text-align:center">
                    <a :href="c.ruta_digital" target="_blank" class="mt-link">
                      <i class="pi pi-external-link"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="mt-empty" style="padding:2.5rem !important">
            <i class="pi pi-inbox"></i>
            <p>No hay cumplidos manuales registrados</p>
          </div>
        </template>
      </div>
      <template #footer>
        <button class="mt-btn-outline" @click="modalcumplidos = false"><i class="pi pi-times"></i> Cerrar</button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Detalle movimiento ══ -->
    <Dialog v-model:visible="modalDetalle" :style="{width:'860px'}"
            :modal="true" class="mt-dialog">
      <template #header>
        <div class="mt-modal-header-custom">
          <div class="mt-modal-header-icon"><i class="pi pi-list"></i></div>
          <div>
            <div class="mt-modal-header-title">Detalle movimiento</div>
            <div class="mt-modal-header-sub"># {{ movimiento_numero }}</div>
          </div>
        </div>
      </template>
      <div class="mt-modal-body">
        <Accordion>
          <template v-for="(detalle_mov, index) in info_detalle_mov" :key="index">
            <AccordionTab>
              <template #header>
                <div class="mt-accordion-header">
                  <div class="mt-accordion-icon"><i class="pi pi-map-marker"></i></div>
                  <div class="mt-accordion-cols">
                    <div>
                      <div class="mt-accordion-label">Origen</div>
                      <div class="mt-accordion-val">{{ detalle_mov.remitente_nombre }}</div>
                      <div class="mt-accordion-place">{{ detalle_mov.origen_descripcion }}</div>
                    </div>
                    <div class="mt-accordion-arrow"><i class="pi pi-arrow-right"></i></div>
                    <div>
                      <div class="mt-accordion-label">Destino</div>
                      <div class="mt-accordion-val">{{ detalle_mov.destinatario_nombre }}</div>
                      <div class="mt-accordion-place">{{ detalle_mov.destino_descripcion }}</div>
                    </div>
                    <div>
                      <div class="mt-accordion-label">Carga</div>
                      <div class="mt-accordion-val">{{ detalle_mov.producto_descripcion }}</div>
                      <div class="mt-accordion-place">{{ new Intl.NumberFormat().format(detalle_mov.peso_final) }} Kg</div>
                    </div>
                    <button class="mt-btn-icon" title="Ver eventos"
                            @click.stop="show_remesa(detalle_mov, index)"
                            :disabled="loading[index]">
                      <i class="pi pi-eye"></i>
                    </button>
                  </div>
                </div>
              </template>
              <div class="mt-detalle-grid">
                <div class="mt-detalle-card">
                  <div class="mt-detalle-card-title">Remitente</div>
                  <div class="mt-info-item"><span class="mt-info-label">NIT</span><span class="mt-info-value">#{{ detalle_mov.remitente_documento }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Nombre</span><span class="mt-info-value">{{ detalle_mov.remitente_nombre }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Dirección</span><span class="mt-info-value">{{ detalle_mov.remitente_direccion }}, {{ detalle_mov.remitente_zona }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Teléfono</span><span class="mt-info-value">{{ detalle_mov.remitente_telefono }}</span></div>
                </div>
                <div class="mt-detalle-card">
                  <div class="mt-detalle-card-title">Destinatario</div>
                  <div class="mt-info-item"><span class="mt-info-label">NIT</span><span class="mt-info-value">#{{ detalle_mov.destinatario_documento }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Nombre</span><span class="mt-info-value">{{ detalle_mov.destinatario_nombre }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Dirección</span><span class="mt-info-value">{{ detalle_mov.destinatario_direccion }}, {{ detalle_mov.destinatario_zona }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Teléfono</span><span class="mt-info-value">{{ detalle_mov.destinatario_telefono }}</span></div>
                </div>
                <div class="mt-detalle-card">
                  <div class="mt-detalle-card-title">Ruta</div>
                  <div class="mt-info-item"><span class="mt-info-label">Origen</span><span class="mt-info-value">{{ detalle_mov.origen_descripcion }} — {{ detalle_mov.origen_detalle }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Destino</span><span class="mt-info-value">{{ detalle_mov.destino_descripcion }} — {{ detalle_mov.destino_detalle }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Valor</span><span class="mt-info-value">${{ new Intl.NumberFormat().format(detalle_mov.valor_declarado) }}</span></div>
                </div>
                <div class="mt-detalle-card">
                  <div class="mt-detalle-card-title">Carga</div>
                  <div class="mt-info-item"><span class="mt-info-label">Producto</span><span class="mt-info-value">{{ detalle_mov.producto_descripcion }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Empaque</span><span class="mt-info-value">{{ detalle_mov.empaque_descripcion }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Peso inicial</span><span class="mt-info-value">{{ detalle_mov.peso_inicial }} kg</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Peso final</span><span class="mt-info-value">{{ detalle_mov.peso_final }} kg</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Unid. inicial</span><span class="mt-info-value">{{ detalle_mov.unidades_inicial }}</span></div>
                  <div class="mt-info-item"><span class="mt-info-label">Unid. final</span><span class="mt-info-value">{{ detalle_mov.unidades_final }}</span></div>
                </div>
              </div>
            </AccordionTab>
          </template>
        </Accordion>
      </div>
      <template #footer>
        <button class="mt-btn-outline" @click="modalDetalle = false"><i class="pi pi-times"></i> Cerrar</button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Eventos remesa ══ -->
    <Dialog v-model:visible="modaldetalleremesas" :style="{width:'920px'}"
            :modal="true" class="mt-dialog">
      <template #header>
        <div class="mt-modal-header-custom">
          <div class="mt-modal-header-icon"><i class="pi pi-map-marker"></i></div>
          <div>
            <div class="mt-modal-header-title">Eventos de remesa</div>
            <div class="mt-modal-header-sub">Movimiento # {{ movimiento_numero }}</div>
          </div>
        </div>
      </template>
      <div class="mt-modal-body">
        <template v-if="code_seway == 1">
          <div class="mt-empty"><i class="pi pi-calendar-times"></i><p>No se encuentran eventos en Seway</p></div>
        </template>
        <template v-else-if="code_seway == 0">
          <div class="mt-empty"><i class="pi pi-info-circle"></i><p>Eventos no disponibles</p></div>
        </template>
        <template v-else>
          <div class="mt-eventos-grid">
            <div v-for="(col, index) in details_remesa" :key="index" class="mt-evento-card">
              <div :class="['mt-evento-icon-wrap', getEventoClass(col.id_events)]">
                <i :class="getEventoIcon(col.id_events)"></i>
              </div>
              <div class="mt-evento-body">
                <div class="mt-evento-title">{{ getEventoLabel(col.id_events) }}</div>
                <div class="mt-evento-date">{{ col.created_at }}</div>
                <div v-if="col.latitude && col.longitude">
                  <a :href="'https://www.google.com.co/maps?q='+col.latitude+','+col.longitude"
                     target="_blank" class="mt-map-link">
                    <i class="pi pi-map-marker"></i> Ver en mapa
                  </a>
                </div>
                <div v-if="col.comment" style="margin-top:.4rem">
                  <button class="mt-btn-sm mt-btn-sm--orange"
                          @click="toggle(index, $event)">
                    <i class="pi pi-comment"></i> Comentario
                  </button>
                  <OverlayPanel :ref="el => setOverlayRef(index, el)"
                    appendTo="body" :showCloseIcon="true" :style="{width:'300px'}">
                    <p style="font-size:.82rem;color:#374151;margin:0">{{ col.comment }}</p>
                  </OverlayPanel>
                </div>
                <div v-if="col.image_event && col.image_event.length > 0" style="margin-top:.4rem">
                  <button class="mt-btn-sm" @click="verImg(col)" :disabled="loader">
                    <i class="pi pi-images"></i>
                    Imágenes ({{ col.image_event.length }})
                  </button>
                  <Galleria :value="img_checklist" :responsiveOptions="galleriaResponsiveOptions"
                    :numVisible="3" containerStyle="max-width:50%" :circular="true"
                    :fullScreen="true" :showItemNavigators="true"
                    v-model:visible="show_galeria_evnets">
                    <template #item="slotProps">
                      <img :src="slotProps.item.blob" :alt="slotProps.item.original_url"
                        style="width:60%;display:block" />
                    </template>
                  </Galleria>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <template #footer>
        <button class="mt-btn-outline" @click="modaldetalleremesas = false"><i class="pi pi-times"></i> Cerrar</button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Sígueme ══ -->
    <Dialog v-model:visible="modalsigueme" :style="{width:'1100px'}"
            :modal="true" class="mt-dialog mt-dialog--wide">
      <template #header>
        <div class="mt-modal-header-custom">
          <div class="mt-modal-header-icon" style="background:#f0fdf4">
            <i class="pi pi-truck" style="color:#166534"></i>
          </div>
          <div>
            <div class="mt-modal-header-title">Sígueme — Seguimiento del viaje</div>
            <div class="mt-modal-header-sub">{{ data_fila.vehiculo_placa }} · {{ data_fila.movimiento_operacion }}</div>
          </div>
        </div>
      </template>

      <div class="mt-sigueme-body">
        <!-- KPI cards -->
        <div class="mt-sigueme-kpis">
          <div class="mt-sigueme-kpi">
            <div class="mt-sigueme-kpi-icon" style="background:#eff6ff"><i class="pi pi-chart-pie" style="color:#1e40af"></i></div>
            <div class="mt-sigueme-kpi-label">Estado del viaje</div>
            <div class="mt-sigueme-kpi-val">{{ detalles_sigueme.viaje?.estado_nombre ?? '—' }}</div>
          </div>
          <div class="mt-sigueme-kpi">
            <div class="mt-sigueme-kpi-icon" style="background:#fff7ed"><i class="pi pi-box" style="color:#9a3412"></i></div>
            <div class="mt-sigueme-kpi-label">Total entregas</div>
            <div class="mt-sigueme-kpi-val">{{ detalles_sigueme.viaje?.detalles_total ?? '—' }}</div>
          </div>
          <div class="mt-sigueme-kpi">
            <div class="mt-sigueme-kpi-icon" style="background:#f0fdf4"><i class="pi pi-check-square" style="color:#166534"></i></div>
            <div class="mt-sigueme-kpi-label">Total entregados</div>
            <div class="mt-sigueme-kpi-val">{{ detalles_sigueme.viaje?.detalles_entregados ?? '—' }}</div>
          </div>
          <div class="mt-sigueme-kpi">
            <div class="mt-sigueme-kpi-icon" style="background:#faf5ff"><i class="pi pi-truck" style="color:#7c3aed"></i></div>
            <div class="mt-sigueme-kpi-label">En tránsito</div>
            <div class="mt-sigueme-kpi-val">{{ detalles_sigueme.viaje?.en_transito ?? '—' }}</div>
          </div>
          <div class="mt-sigueme-kpi">
            <div class="mt-sigueme-kpi-icon" style="background:#eff6ff"><i class="pi pi-bookmark" style="color:#1e40af"></i></div>
            <div class="mt-sigueme-kpi-label">Placa</div>
            <div class="mt-sigueme-kpi-val"><span class="mt-placa">{{ data_fila.vehiculo_placa ?? '—' }}</span></div>
          </div>
          <div class="mt-sigueme-kpi">
            <div class="mt-sigueme-kpi-icon" style="background:#fef9c3"><i class="pi pi-directions" style="color:#854d0e"></i></div>
            <div class="mt-sigueme-kpi-label">Operación</div>
            <div class="mt-sigueme-kpi-val">{{ data_fila.movimiento_operacion ?? '—' }}</div>
          </div>
        </div>

        <!-- Tabs detalles / temperaturas -->
        <div class="mt-sigueme-tabs">
          <TabView v-model="activeIndexSeway" @tab-click="handleTabChange">
            <TabPanel header="Detalles">
              <div class="mt-sigueme-tab-content">
                <template v-if="detalles_sigueme?.success === true">
                  <div class="mt-tabla-wrap" style="margin:0">
                    <table class="mt-tabla">
                      <thead>
                        <tr>
                          <th>Generador / NIT</th>
                          <th>Remitente</th>
                          <th>Destinatario</th>
                          <th>Carga</th>
                          <th>Estado</th>
                          <th>Fecha entrega</th>
                          <th>Recibido por</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!detalles_sigueme.viaje?.detalles?.length">
                          <td colspan="7" class="mt-empty" style="padding:2rem !important"><i class="pi pi-inbox"></i><p>Sin detalles</p></td>
                        </tr>
                        <tr v-for="(det, di) in (detalles_sigueme.viaje?.detalles ?? [])" :key="di">
                          <td><div class="mt-gen-name">{{ det.generador_nombre }}</div><div class="mt-cell-sub">{{ det.generador_nit }}</div></td>
                          <td>{{ det.remitente_nombre }}</td>
                          <td>{{ det.destinatario_nombre }}</td>
                          <td>
                            <div class="mt-cell-sub">Prod: <strong>{{ det.producto_descripcion }}</strong></div>
                            <div class="mt-cell-sub">Cant: {{ det.cantidad }} · Peso: {{ det.peso }}</div>
                          </td>
                          <td><span class="mt-badge mt-badge--azul">{{ det.estado_nombre }}</span></td>
                          <td>{{ det.fecha_entrega }}</td>
                          <td>{{ det.recibido_por }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
                <template v-else>
                  <div class="mt-empty"><i class="pi pi-exclamation-triangle"></i><p>Error al conectarse con Sígueme. Comuníquese con un administrador.</p></div>
                </template>
              </div>
            </TabPanel>

            <TabPanel header="Temperaturas">
              <div class="mt-sigueme-tab-content">
                <ProgressBar v-if="loader" mode="indeterminate" style="height:3px;margin-bottom:1rem" />
                <template v-if="temperaturas_sigueme && temperaturas_sigueme.length === 0">
                  <div class="mt-empty"><i class="pi pi-thermometer"></i><p>Sin temperaturas registradas para este viaje</p></div>
                </template>
                <template v-else-if="temperaturas_sigueme && temperaturas_sigueme.length > 0">
                  <div class="mt-temp-layout">
                    <!-- Indicadores -->
                    <div class="mt-temp-indicators">
                      <div class="mt-temp-ind-card">
                        <div class="mt-temp-ind-label">Temp. inicial</div>
                        <div class="mt-temp-ind-val">{{ temperaturas_sigueme[0]?.temperaturas_fake }} °C</div>
                        <div class="mt-temp-ind-sub">{{ temperaturas_sigueme[0]?.fecha }}</div>
                        <ProgressBar :value="parseFloat(temperaturas_sigueme[0]?.temperaturas_fake)" :showValue="false" style="height:6px;margin-top:.5rem" />
                      </div>
                      <div class="mt-temp-ind-card">
                        <div class="mt-temp-ind-label">Temp. final</div>
                        <div class="mt-temp-ind-val">{{ temperaturas_sigueme[temperaturas_sigueme.length-1]?.temperaturas_fake }} °C</div>
                        <div class="mt-temp-ind-sub">{{ temperaturas_sigueme[temperaturas_sigueme.length-1]?.fecha }}</div>
                        <ProgressBar :value="parseFloat(temperaturas_sigueme[temperaturas_sigueme.length-1]?.temperaturas_fake)" :showValue="false" style="height:6px;margin-top:.5rem" />
                      </div>
                      <div class="mt-temp-ind-card">
                        <div class="mt-temp-ind-label">Promedio</div>
                        <div class="mt-temp-ind-val">{{ promedio_temperatura }} °C</div>
                        <ProgressBar :value="parseFloat(promedio_temperatura)" :showValue="false" style="height:6px;margin-top:.5rem" />
                      </div>
                      <div class="mt-temp-ind-card mt-temp-ind-card--max">
                        <div class="mt-temp-ind-label">Máxima</div>
                        <div class="mt-temp-ind-val">{{ temperatua_max }} °C</div>
                        <ProgressBar :value="parseFloat(temperatua_max)" :showValue="false" style="height:6px;margin-top:.5rem" />
                      </div>
                      <div class="mt-temp-ind-card mt-temp-ind-card--min">
                        <div class="mt-temp-ind-label">Mínima</div>
                        <div class="mt-temp-ind-val">{{ temperatua_min }} °C</div>
                        <template v-if="temperatua_min > 0">
                          <ProgressBar :value="parseFloat(temperatua_min)" :showValue="false" style="height:6px;margin-top:.5rem" />
                        </template>
                      </div>
                    </div>
                    <!-- Gráfica -->
                    <div class="mt-temp-chart">
                      <Chart type="line" :data="chartData" :options="chartOptions" />
                    </div>
                  </div>
                </template>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>

      <template #footer>
        <button class="mt-btn-outline" @click="modalsigueme = false"><i class="pi pi-times"></i> Cerrar</button>
      </template>
    </Dialog>

  </div>
</template>

<script>
// import axios from 'axios'
export default {
	data() {
		return {
			message: [],
			customers: [],
			customers_group: [],
			details_remesa: [],
			chartData: {
				labels: ["2022-07-29 14:37:32", "2022-07-29 17:45:11", "2022-07-29 18:20:15"],
				datasets: [
				{
					label: "Temperatura",
					backgroundColor: "rgba(75, 192, 192, 0.2)",
					borderColor: "rgba(75, 192, 192, 1)",
					data: [16.8, 24.4, 37.5]
				}
				]
			},
			chartOptions: {
				// maintainAspectRatio: false,
				responsive: true,
				width: 400, // Define el ancho deseado para la gráfica
				height: 200, // Define el alto deseado para la gráfica
				scales: {
					y: {
						beginAtZero: true
					}
				}
			},
			customer_selected: null,
			modalcumplidos: false,
			modalsigueme: false,
			documento_movimiento: '',
			events2: [
                "2020", "2021", "2022", "2023"
            ],
            detalle_movimientos: [],
			remesas: [],
            info_docs_movimientos: [],
			generadores: [],
			estados_mov: [],
			cumplidos: [],
			detalles_sigueme: [],
			doughnutData: null,
			doughnutOptions: null,
			img_checklist: [],
			temperaturas_sigueme: [],
			columns: [0, 1, 2, 3, 4, 5],
			num_movimiento: '',
			username:null,
			code_seway: '',
			activeIndexSeway: 0,
			loader: false,
			movimiento_numero: '',
			modalActores: false,
			modalDetalle: false,
			modaldetalleremesas: false,
			modaldocumentos: false,
			email:null,
			campo_selected: null,
			select_estado: null,
			selectedProducts: null,
			modal_img: false,
			loading: [false, false, false],
			loading_reme: [false, false, false],
			count: 0,
			show_galeria_evnets: false,
			data_fila: [],
			img_conductor: [],
			img_vehiculo: [],
			info_detalle_mov: [],
			overlayRefs: [],
			placa: '',
			text_filter: '',
			galleriaResponsiveOptions: [
                {
                    breakpoint: "724px",
                    numVisible: 5,
                },
                {
                    breakpoint: "660px",
                    numVisible: 4,
                },
                {
                    breakpoint: "168px",
                    numVisible: 3,
                },
                {
                    breakpoint: "160px",
                    numVisible: 1,
                },
            ],
            pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			campos_tabla: [
				{name: 'Fecha', code: 'fecha'},
				{name: 'Placa', code: 'placa'},
				{name: 'Generador', code: 'estado'}
			],
			frmfiltros: {
                fechasolicitud: '',
                rangofechasolicitud: false,
                fechasolicitudrango: '',
                cliente: '',
                direccion: '',
                mensajero: '',
                estadopedido: 0
            },
			promedio_temperatura: 0,
			temperatua_max: 0,
			temperatua_min: 0,
			ingresoCostumer: false
		}
	},
	mounted(){
		// this.cargar_empresas();
        this.loadDataTable1(1);
	},
	methods:{
		getEventoLabel(id) {
			const labels = {
				2:'Llegada de Carga', 3:'Inicio de Carga', 4:'Fin de Carga',
				5:'Carga aceptada', 6:'Llegada a sitio Descargue', 7:'Inicio Descargue',
				8:'Fin Descargue', 9:'Descarga Aceptada', 10:'Entrega Pendiente',
				11:'Entrega Exitosa', 12:'Entrega Rechazada', 13:'Planta de carga reservada',
				14:'Inicio de carga en planta', 15:'Fin de carga en planta',
				16:'Inicio de descarga en planta', 17:'Fin de descarga en planta',
				18:'Descargada en planta no reservada'
			};
			return labels[id] ?? 'Evento '+id;
			},
			getEventoClass(id) {
			const exitosos = [5,9,11]; const pendientes = [10]; const rechazados = [12];
			if (exitosos.includes(id)) return 'mt-evento-icon--verde';
			if (rechazados.includes(id)) return 'mt-evento-icon--rojo';
			if (pendientes.includes(id)) return 'mt-evento-icon--naranja';
			return 'mt-evento-icon--azul';
			},
			getEventoIcon(id) {
			const icons = {
				2:'pi-truck', 3:'pi-box', 4:'pi-box', 5:'pi-check-circle',
				6:'pi-building', 7:'pi-download', 8:'pi-check', 9:'pi-truck',
				10:'pi-exclamation-triangle', 11:'pi-verified', 12:'pi-times-circle',
				13:'pi-map-marker', 14:'pi-building', 15:'pi-building',
				16:'pi-building', 17:'pi-building', 18:'pi-map-marker'
			};
			return 'pi '+(icons[id] ?? 'pi-circle');
		},
        loadDataTable1(page){
			// this.cleartable();
            const cookieName = 'Email';
			const IdRol = 'IdRol';
			this.loader = true;
			this.loading[0] = true;
			
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})

			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
                window.api.call('post', '/cargar_customers?&page='+page, {email: email,id_rol: id_rol}).then( function(response) {
                    if(response.status == 200){
						if (response.data.data.length == 1) {
							_that.customers_group = response.data.data;
							_that.customer_selected = response.data.data[0].id_customer;
							_that.load(0,1);
						}else{
							_that.loader = false;
							_that.customers_group = response.data.data;
							_that.loading[0] = false;
						}
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
					_that.loading[0] = false;
                });
		},
		verImg(data){
			
			console.log(data);
			// this.img_checklist = data.image_event;
			// this.modal_img = true;
			
			
			this.img_checklist = [];

			var _that = this;
			this.loader = true;
			var nombre_campo_img = 'image_url';
			var url = 'img_public';
			window.api.call('post', url, {imagenes: data.image_event,nombre_campo_img: nombre_campo_img}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.img_checklist = response.data.data.images;
					// _that.modal_img = true;
					_that.show_galeria_evnets = true;
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
			});
		},
		select_proveedor(){
			// console.log(this.customer_selected);
			if (this.customer_selected!=null) {
				this.load(0,1);
				// this.load_indicadores = true;
			}else{

			}
		},
		openNew(){

		},
		addColumn() {
				this.columns = [...this.columns, this.columns.length];
			},
			removeColumn() {
				this.columns.pop();
			},
		openFiltersExport(){
			// this.modalFiltros = true;
		},
		openModalcumplidos(data,slot){
			// console.log(data);
			// this.modalcumplidos = true;
			this.loading[slot.index] = true;
			this.data_fila = [];
			this.cumplidos = [];
			var _that = this;
			var url = 'traer_cumplidos';
			window.api.call('post', url, {id_customer: this.customer_selected,movimiento_id: data.movimiento_id}).then( function(response) {
				if(response.status == 200){
					_that.data_fila = data;
					_that.loading[slot.index] = false;
					_that.cumplidos = response.data.data;
					// _that.img_vehiculo = response.data.data;
					// _that.img_conductor = response.data.img_conductor;
					_that.modalcumplidos = true;
				}
			}).catch(function (err) {
				_that.loading[0] = false;
				_that.loading[slot.index] = false;
				console.log(err);
			});
		},
		openModalDetalleSigueme(data,slot){
			// console.log(data);
			this.loading[slot.index] = true;
			this.data_fila = [];
			this.detalles_sigueme = [];
			var _that = this;
			var url = 'cargar_sigueme_detalle';
			this.id_viaje = data.id_viaje;
			window.api.call('post', url, {id_customer: this.customer_selected,id_viaje: data.id_viaje}).then( function(response) {
				if(response.status == 200){
					_that.loading[slot.index] = false;
					if (response.data.data.success==false) {
						_that.$toast.add({severity:'error', summary: 'Error', detail:response.data.data.message, life: 4000});
					}else{
						_that.data_fila = data;
						
						_that.detalles_sigueme = response.data.data;
						// _that.detalles_sigueme = response.data.response_FEKA;
						_that.modalsigueme = true;
					}
				}
			}).catch(function (err) {
				_that.loading[0] = false;
				_that.loading[slot.index] = false;
				console.log(err);
			});
		},
		async cargarTemperaturas(){
			this.temperaturas_sigueme = [];
			this.loader = true;
			var _that = this;
			var url = 'cargar_sigueme_temperaturas_generador';
			window.api.call('post', url, {id_customer: this.customer_selected,id_viaje: this.id_viaje}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					// if (response.data.data.success==false) {
					// 	_that.$toast.add({severity:'error', summary: 'Error', detail:response.data.data.message, life: 4000});
					// }else{
						_that.$toast.add({ severity: 'success', summary: 'Temperaturas:', detail: '', life: 6000 });
						_that.temperaturas_sigueme = response.data.array_temperaturas;
						// if (_that.temperaturas_sigueme.success==true) {
							_that.chartData = _that.getchartData(response.data.array_temperaturas);
							// _that.chartData = _that.getchartData(response.data.data.viaje.temperaturas);
							// response.data.data.viaje.temperaturas.forEach(temperatura => {
							// 	_that.doughnutData = _that.getDoughnutData(temperatura);
							// 	_that.doughnutOptions = _that.getDoughnutOptions();
							// });
							
						// }
					// }
					
				}
			}).catch(function (err) {
				_that.loader = false;
				console.log(err);
			});
		},
		getDoughnutData(data) {
			// const { deeporangeColor, cyanColor, tealColor, greenColor,
            //     lightgreenColor, orangeColor } = this.getColors();
            const { rojoDiablo, blanquito } = this.getColors();
            const borderColor = getComputedStyle(document.body).getPropertyValue('--divider-color') || 'rgba(160, 167, 181, .3)';
			var vacio = 100-parseInt(data.temperatura);
            return {
                labels: [data.temperatura+'°C'],
                datasets: [
                    {
                        data: [parseInt(data.temperatura),vacio],
                        backgroundColor: [rojoDiablo,blanquito],
                        // backgroundColor: [deeporangeColor, deeporangeColor, cyanColor, tealColor, greenColor, lightgreenColor, orangeColor],
                        borderColor
                    }
                ]
            };
        },
		getchartData(data) {
			var labels = [];
			var temperaturas = [];
			this.promedio_temperatura = 0;
			this.temperatua_max = 0;
			this.temperatua_min = 0;
			// Recorre los datos y extrae las etiquetas (fechas) y las temperaturas
			data.forEach(temperatura => {
				// if (labels.length < 10) {
					labels.push(temperatura.fecha);
					temperaturas.push(temperatura.temperaturas_fake);
					this.promedio_temperatura = this.promedio_temperatura + parseFloat(temperatura.temperaturas_fake);
				// }
			});
			// Define el objeto del conjunto de datos
			var dataset = {
				label: "Temperatura",
				backgroundColor: "rgba(75, 192, 192, 0.2)",
				borderColor: "rgba(75, 192, 192, 1)",
				data: temperaturas
			};
			this.promedio_temperatura = this.promedio_temperatura/(data.length - 1);
			this.promedio_temperatura = this.promedio_temperatura.toFixed(1);

			let valoresTemperaturas = data.map(item => parseFloat(item.temperaturas_fake));
			this.temperatua_max = Math.max(...valoresTemperaturas);
			this.temperatua_min = Math.min(...valoresTemperaturas);


			// Devuelve el objeto chartData con las etiquetas y el conjunto de datos
			return {
				labels: labels,
				datasets: [dataset] // Convierte el objeto en un array para que sea válido
			};

        },
		getDoughnutOptions() {
            const textColor = getComputedStyle(document.body).getPropertyValue('--text-color') || 'rgba(0, 0, 0, 0.87)';
            const fontFamily = getComputedStyle(document.body).getPropertyValue('--font-family');
            return {
                responsive: true,
                aspectRatio: 2,
                plugins: {
                    legend: {
                        position: 'top',
                        labels: {
                            font: {
                                family: fontFamily
                            },
                            color: textColor
                        }
                    }
                },
                circumference: 180,
                rotation: -90,
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            };
        },
		getColors() {
            const isLight = this.$appState.layoutMode === 'light';
				return {
					blanquito: isLight ? '#F0F0F0' : '#EEF7FE',
					rojoDiablo: isLight ? '#DB353A' : '#FFAB91'
				}
		},
		handleTabChange(event) {
			// if (!this.tabClicked) {
				// console.log('Cambiaste de TabPanel. Nuevo índice activo:', event.index);

				switch (event.index) {
					case 0:
						console.log('aaa');
						
						break;
					case 1:
						// console.log('bbb');
						this.cargarTemperaturas();
						// EventBus.emit('traer-inspeccion');
						// EventBus.emit('show-container',response.data.rol);
						break;
					default:
						break;
				}
				// this.tabClicked = true; // Establece la variable de estado en verdadero para evitar futuras ejecuciones
			// }
		},
		openactores(data,slot){
			// this.data_fila = data;
			// console.log(data);
			// console.log(slot.index);
			this.loading[slot.index] = true;
			this.data_fila = [];
			this.img_vehiculo = [];
			this.img_conductor = [];
			var _that = this;
			var url = 'info_actores';
			window.api.call('post', url, {placa: data.vehiculo_placa,conductor_documento: data.conductor_documento}).then( function(response) {
				if(response.status == 200){
					_that.data_fila = data;
					_that.loading[slot.index] = false;
					_that.img_vehiculo = response.data.img_vehiculo;
					_that.img_conductor = response.data.img_conductor;
					_that.modalActores = true;
				}
			}).catch(function (err) {
				_that.loading[0] = false;
				_that.loading[slot.index] = false;
				console.log(err);
			});
		},
		limpiar(){
			this.placa = null;
			this.text_filter = null;
			this.select_estado = null;
			// this.customer_selected = null;
			this.num_referencia = '';
			this.num_movimiento = '';
			this.frmfiltros.rangofechasolicitud = '';
			this.frmfiltros.fechasolicitudrango = '';
			this.remitente = '';
			this.detalle_movimientos = [];
			this.pagination = {};
			this.destinatario = '';
			// this.load(0,1);

		},
		opendocumentos(data,slot){
			// console.log(data);
			// console.log(slot.index);
			this.loading[slot.index] = true;
			this.data_fila = [];
			this.remesas = [];
			this.documento_movimiento = '';
			this.estados_mov = [];
			this.info_docs_movimientos = [];
			// this.img_conductor = [];
			this.movimiento_numero = data.movimiento_numero;
			var _that = this;
			var url = 'documentos_mov_transporte';
			window.api.call('post', url, {id_customer: this.customer_selected,movimiento_id: data.movimiento_id}).then( function(response) {
				if(response.status == 200){
					_that.data_fila = data;
					_that.loading[slot.index] = false;
					_that.modaldocumentos = true;
					if (response.data.manifiesto.length > 0) {
						_that.documento_movimiento = response.data.manifiesto[0].url_documento_s3;
						_that.info_docs_movimientos = response.data.manifiesto[0];
					}
					_that.remesas = response.data.remesas;
					if (response.data.estados.length > 0) {
						_that.estados_mov = response.data.estados[0];
					}
					
					
				}
			}).catch(function (err) {
				_that.loading[0] = false;
				_that.loading[slot.index] = false;
				console.log(err);
			});
		},
		verDetalle(data,slot){
			this.info_detalle_mov = [];
			this.loading[slot.index] = true;
			// console.log(data);
			this.movimiento_numero = data.movimiento_numero;
			var _that = this;
			var url = 'detalle_mov_transporte_generador';
			window.api.call('post', url, {id_customer: this.customer_selected,movimiento_id: data.movimiento_id}).then( function(response) {
				if(response.status == 200){
					// console.log(response.data.data);
					_that.info_detalle_mov = response.data.data_total;
					_that.modalDetalle = true;
					_that.loading[slot.index] = false;
				}
			}).catch(function (err) {
				_that.loading[0] = false;
				console.log(err);
				_that.loading[slot.index] = false;
			});
		},
		show_remesa(data,index){
			this.details_remesa = [];
			this.code_seway = '';
			this.loading_reme[index] = true;
			this.loading[index] = true;
			this.loader = true;
			var _that = this;
			var url = 'show_remesas_cumplidos';
			window.api.call('post', url, {id_customer: this.customer_selected,id_detalle: data.detalle_id}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.modaldetalleremesas = true;
					_that.details_remesa = response.data.data;
					_that.code_seway = response.data.code;
					_that.loading_reme[index] = false;
					_that.loading[index] = false;
					
				}
			}).catch(function (err) {
				_that.loader = false;
				_that.loading[0] = false;
				_that.$toast.add({severity:'error', summary: 'Info no disponible', detail:err.data.data, life: 4000});
				_that.loading_reme[index] = false;
				_that.loading[index] = false;
			});
		},
        onChangePage(page) {
			// console.log(page);
			// console.log(page.page+1);
				if(this.search_paginador == false){
					this.loadDataTable1((page.page+1));
				}else{
					this.load(0,page.page+1);
				}
		},
		salirCustomer(){
			this.ingresoCostumer = false;
		},
		load(index,page){
			// console.log(index);
			
			// console.log(page);
			if (this.customer_selected==null) {
				this.$toast.add({severity:'error', summary: 'Selecciona una Empresa de transporte', detail:'', life: 4000});
			}else{
				if(this.text_filter && !this.frmfiltros.fechasolicitudrango && this.frmfiltros.rangofechasolicitud == true){
					this.$toast.add({severity:'error', summary: 'Rango incorrecto', detail:'Ingresa fecha inicial y fecha final', life: 4000});
					return;
				}
				this.loading[0] = true;
				var _that = this;
				this.detalle_movimientos = [];
				if(this.placa){
					this.placa = this.placa.replaceAll('-', '');
				}
				
				this.generadores = [];
				var url = 'cargar_mov_transporte_consolidado?&page='+page;
				window.api.call('post', url, {id_customer: this.customer_selected,nom_campo: this.campo_selected,nit_generador: this.select_estado,placa: this.placa,num_mov: this.num_movimiento,fecha: this.text_filter,fecha_fin: this.frmfiltros.fechasolicitudrango,rango: this.frmfiltros.rangofechasolicitud}).then( function(response) {
					if(response.status == 200){
						_that.detalle_movimientos = response.data.data.data;
						
						_that.generadores = response.data.generadores;
						_that.pagination = response.data.data;
						// console.log(_that.generadores);
						_that.loading[0] = false;
					}
				}).catch(function (err) {
					_that.loading[0] = false;
					console.log(err);
				});
			}
		},
		setOverlayRef(index, el) {
			this.overlayRefs[index] = el;
		},
		toggle(index, event) {
			const panel = this.overlayRefs[index];
			if (panel && typeof panel.toggle === 'function') {
			panel.toggle(event);
			}
		}
	},
	computed: {
        isRTL() {
			return this.$appState.RTL;
		}
    },
}
</script>

<style scoped lang="scss">
$navy:#0A354E; $orange:#EB7D10; $white:#fff;
$g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

.mt-wrap { background:$bg; min-height:100vh; padding:1.25rem .5rem; }

/* ── Topbar ── */
.mt-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1.25rem; flex-wrap:wrap; gap:.75rem; }
.mt-title  { font-size:1.35rem; font-weight:700; color:$g700; margin:0 0 .2rem; }
.mt-sub    { font-size:.8rem; color:$g500; margin:0; }

/* ── Buttons ── */
.mt-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.mt-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }
.mt-btn-icon     { display:inline-flex; align-items:center; justify-content:center; width:30px; height:30px; background:$white; border:1px solid $g200; border-radius:6px; cursor:pointer; color:$g700; font-size:.8rem; transition:all .15s; &:hover{border-color:$navy;color:$navy;} &:disabled{opacity:.5;} }
.mt-btn-icon--sigueme { &:hover{border-color:#7c3aed;color:#7c3aed;} }
.mt-btn-sm { display:inline-flex; align-items:center; gap:.3rem; background:$white; border:1px solid $g200; border-radius:6px; padding:.3rem .65rem; font-size:.75rem; font-weight:600; cursor:pointer; color:$g700; &:hover{border-color:$navy;color:$navy;} &:disabled{opacity:.5;} }
.mt-btn-sm--orange { &:hover{border-color:$orange;color:$orange;} }
.mt-link { color:$navy; font-size:.82rem; text-decoration:none; &:hover{text-decoration:underline;} }

/* ── Panel búsqueda ── */
.mt-search-panel { background:$white; border:1px solid $g200; border-radius:$r; padding:1.25rem 1.5rem; margin-bottom:1.25rem; }
.mt-search-section-label { display:flex; align-items:center; gap:.4rem; font-size:.72rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; padding-bottom:.6rem; border-bottom:1px solid $g200; margin-bottom:.875rem; i{font-size:12px;} }
.mt-search-top      { display:flex; align-items:flex-end; gap:.75rem; flex-wrap:wrap; }
.mt-search-top-btns { display:flex; gap:.5rem; flex-shrink:0; }
.mt-filtros-grid    { display:grid; grid-template-columns:repeat(3,1fr); gap:.75rem; }
.mt-form-field { display:flex; flex-direction:column; gap:.3rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;display:flex;align-items:center;gap:.5rem;} }
.mt-range-toggle { display:flex; align-items:center; gap:.3rem; margin-left:auto; }

/* ── Tabla principal ── */
.mt-tabla-wrap { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; }
.mt-tabla { width:100%; border-collapse:collapse; font-size:.82rem; }
.mt-tabla thead tr { background:#f8f9fa; }
.mt-tabla th { text-align:left; padding:.65rem 1rem; font-size:.63rem; font-weight:700; letter-spacing:.7px; text-transform:uppercase; color:$g500; border-bottom:1px solid $g200; white-space:nowrap; }
.mt-tabla td { padding:.75rem 1rem; border-bottom:1px solid #f1f3f4; color:$g700; vertical-align:middle; }
.mt-tabla tbody tr:last-child td { border-bottom:none; }
.mt-tabla tbody tr:hover td { background:#fafbfc; }

.mt-cell-label { font-size:.65rem; font-weight:700; color:$g500; text-transform:uppercase; letter-spacing:.4px; margin-bottom:.2rem; }
.mt-cell-sub   { font-size:.75rem; color:$g500; }
.mt-cell-op    { font-size:.78rem; font-weight:500; color:$g700; }
.mt-ref        { font-family:monospace; font-size:.85rem; font-weight:700; color:$navy; }
.mt-gen-name   { font-size:.82rem; font-weight:600; color:$g700; }
.mt-placa      { font-family:monospace; font-size:.78rem; font-weight:700; background:#eff6ff; color:#1e40af; padding:.15rem .5rem; border-radius:4px; }
.mt-fecha      { font-size:.72rem; color:$g500; margin-top:.2rem; }
.mt-estado     { font-size:.75rem; font-weight:600; color:$g700; }
.mt-row-actions { display:flex; gap:.35rem; justify-content:center; }

/* ── Badges ── */
.mt-badge { display:inline-flex; align-items:center; gap:.25rem; font-size:.7rem; font-weight:700; padding:.18rem .55rem; border-radius:20px; }
.mt-badge--naranja { background:#fff7ed; color:#9a3412; }
.mt-badge--azul    { background:#eff6ff; color:#1e40af; }
.mt-badge--verde   { background:#f0fdf4; color:#166534; }

/* ── Paginación ── */
.mt-pagination { display:flex; justify-content:space-between; align-items:center; padding:.75rem 1rem; border-top:1px solid $g200; font-size:.78rem; color:$g500; }
.mt-paginator  { background:transparent; border:none; }

/* ── Empty / skeleton ── */
.mt-empty { text-align:center; padding:3rem !important; color:$g500; i{font-size:1.75rem;display:block;margin-bottom:.75rem;} p{font-size:.875rem;margin:0;} }
@keyframes shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
.mt-skeleton-wrap { padding:1rem; }
.mt-skeleton-row  { height:56px; border-radius:8px; background:linear-gradient(90deg,#ececec 25%,#f5f5f5 50%,#ececec 75%); background-size:1200px; animation:shimmer 1.4s infinite linear; margin-bottom:.5rem; }

/* ── Modales ── */
.mt-dialog {
  :deep(.p-dialog-header){ padding:.875rem 1.25rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:0 !important; }
  :deep(.p-dialog-footer){ border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; }
}
.mt-dialog--wide :deep(.p-dialog-content){ padding:0 !important; }

.mt-modal-header-custom { display:flex; align-items:center; gap:.75rem; width:100%; }
.mt-modal-header-icon   { width:36px; height:36px; border-radius:8px; background:#eff6ff; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:15px;color:$navy;} }
.mt-modal-header-title  { font-size:1rem; font-weight:700; color:$g700; }
.mt-modal-header-sub    { font-size:.78rem; color:$g500; margin-top:2px; }

.mt-modal-body { padding:1.25rem 1.5rem; display:flex; flex-direction:column; gap:1.25rem; }

/* Actores */
.mt-actor-section { background:#fafbfc; border:1px solid $g200; border-radius:10px; padding:1rem; }
.mt-actor-section-header { display:flex; align-items:center; gap:.75rem; margin-bottom:.875rem; }
.mt-actor-icon   { width:36px; height:36px; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:15px;} }
.mt-actor-title  { font-size:.9rem; font-weight:700; color:$g700; }
.mt-actor-sub    { font-size:.75rem; color:$g500; }
.mt-info-grid    { display:grid; grid-template-columns:repeat(2,1fr); gap:.5rem; }
.mt-info-item    { display:flex; flex-direction:column; gap:.15rem; }
.mt-info-label   { font-size:.68rem; font-weight:700; color:$g500; text-transform:uppercase; letter-spacing:.4px; }
.mt-info-value   { font-size:.82rem; color:$g700; font-weight:500; }

/* Accordion detalle */
.mt-accordion-header { display:flex; align-items:center; gap:.875rem; width:100%; flex-wrap:wrap; }
.mt-accordion-icon   { width:32px; height:32px; border-radius:8px; background:#eff6ff; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:13px;color:$navy;} }
.mt-accordion-cols   { display:flex; align-items:flex-start; gap:1.25rem; flex:1; flex-wrap:wrap; }
.mt-accordion-arrow  { color:$g500; align-self:center; }
.mt-accordion-label  { font-size:.65rem; font-weight:700; color:$g500; text-transform:uppercase; letter-spacing:.5px; }
.mt-accordion-val    { font-size:.82rem; font-weight:600; color:$g700; }
.mt-accordion-place  { font-size:.72rem; color:$g500; }
.mt-detalle-grid     { display:grid; grid-template-columns:repeat(2,1fr); gap:.875rem; padding:1rem 0; }
.mt-detalle-card     { background:#fafbfc; border:1px solid $g200; border-radius:8px; padding:.875rem; display:flex; flex-direction:column; gap:.5rem; }
.mt-detalle-card-title { font-size:.75rem; font-weight:700; color:$navy; text-transform:uppercase; letter-spacing:.5px; padding-bottom:.5rem; border-bottom:1px solid $g200; }

/* Eventos */
.mt-eventos-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(230px,1fr)); gap:.875rem; }
.mt-evento-card  { background:$white; border:1px solid $g200; border-radius:10px; padding:1rem; display:flex; gap:.75rem; transition:all .15s; &:hover{border-color:#93c5fd;background:#f8faff;} }
.mt-evento-icon-wrap { width:34px; height:34px; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:13px;} }
.mt-evento-icon--verde  { background:#f0fdf4; border:1px solid #86efac; i{color:#166534;} }
.mt-evento-icon--naranja{ background:#fff7ed; border:1px solid #fed7aa; i{color:#9a3412;} }
.mt-evento-icon--rojo   { background:#fef2f2; border:1px solid #fecaca; i{color:#dc2626;} }
.mt-evento-icon--azul   { background:#eff6ff; border:1px solid #bfdbfe; i{color:#1e40af;} }
.mt-evento-body  { flex:1; }
.mt-evento-title { font-size:.82rem; font-weight:700; color:$g700; margin-bottom:.35rem; }
.mt-evento-date  { font-size:.72rem; color:$g500; margin-bottom:.4rem; }
.mt-map-link     { display:inline-flex; align-items:center; gap:.3rem; font-size:.75rem; font-weight:600; color:#1e40af; text-decoration:none; &:hover{text-decoration:underline;} }

/* ── Sígueme ── */
.mt-sigueme-body { display:flex; flex-direction:column; gap:0; }
.mt-sigueme-kpis { display:grid; grid-template-columns:repeat(6,1fr); gap:.65rem; padding:1.25rem 1.5rem; background:#f8f9fa; border-bottom:1px solid $g200; }
.mt-sigueme-kpi  { background:$white; border:1px solid $g200; border-radius:10px; padding:.875rem; display:flex; flex-direction:column; align-items:center; gap:.4rem; text-align:center; transition:all .15s; &:hover{border-color:#93c5fd;transform:translateY(-2px);} }
.mt-sigueme-kpi-icon  { width:34px; height:34px; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:14px;} }
.mt-sigueme-kpi-label { font-size:.65rem; font-weight:700; color:$g500; text-transform:uppercase; letter-spacing:.5px; }
.mt-sigueme-kpi-val   { font-size:1.1rem; font-weight:800; color:$g700; }

.mt-sigueme-tabs { padding:1.25rem 1.5rem; }
.mt-sigueme-tab-content { padding:.875rem 0; }

/* Temperaturas */
.mt-temp-layout     { display:grid; grid-template-columns:240px 1fr; gap:1.25rem; }
.mt-temp-indicators { display:flex; flex-direction:column; gap:.65rem; }
.mt-temp-ind-card   { background:#f8f9fa; border:1px solid $g200; border-radius:8px; padding:.75rem; }
.mt-temp-ind-card--max { border-left:3px solid #dc2626; }
.mt-temp-ind-card--min { border-left:3px solid #1e40af; }
.mt-temp-ind-label  { font-size:.68rem; font-weight:700; color:$g500; text-transform:uppercase; letter-spacing:.4px; }
.mt-temp-ind-val    { font-size:1.1rem; font-weight:700; color:$g700; margin:.2rem 0; }
.mt-temp-ind-sub    { font-size:.68rem; color:$g500; }
.mt-temp-chart      { background:$white; border:1px solid $g200; border-radius:8px; padding:1rem; }

/* Responsive */
@media(max-width:1100px) { .mt-sigueme-kpis { grid-template-columns:repeat(3,1fr); } }
@media(max-width:900px)  { .mt-filtros-grid { grid-template-columns:repeat(2,1fr); } .mt-temp-layout { grid-template-columns:1fr; } }
@media(max-width:600px)  { .mt-filtros-grid { grid-template-columns:1fr; } .mt-detalle-grid { grid-template-columns:1fr; } .mt-sigueme-kpis { grid-template-columns:repeat(2,1fr); } }
</style>
